import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
    import { PlotStatus } from '@/types/LandPLot';

    interface Props {
        landPlotStatus: PlotStatus | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LandStatus',
  props: {
    landPlotStatus: { default: null }
  },
  setup(__props: any) {

    const props = __props;

    const landPlotStatusMeta = computed(() => {
        switch (props.landPlotStatus) {
            case PlotStatus.free:
                return { text: 'Свободен', class: PlotStatus.free };
            case PlotStatus.booked:
                return { text: 'Забронирован', class: PlotStatus.booked };
            case PlotStatus.occupied:
                return { text: 'Занят', class: PlotStatus.occupied };
            default:
                return { text: '', class: '' };
        }
    });

return (_ctx: any,_cache: any) => {
  return (_ctx.landPlotStatus)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["land-status", `land-status--${landPlotStatusMeta.value.class}`])
      }, _toDisplayString(landPlotStatusMeta.value.text), 3))
    : _createCommentVNode("", true)
}
}

})